// select the iframe
const audioPlayerIframe = document.querySelector('.player-iframe-audio');

if (audioPlayerIframe) {

    // select the playlist items
    const audioPlaylistItems = document.querySelectorAll('.playlist--item button');

    audioPlaylistItems.forEach((item) => {
        // get the data attribute of each item
        const audioProgramDetail = JSON.parse(item.getAttribute('data-program-detail'));
        
        // add a request param to each url
        audioProgramDetail.url = audioProgramDetail.url + '?detsky_obsah=1';

        item.addEventListener('click', (e) => {
            // change URL if its not the current one
            if(audioPlayerIframe.src != audioProgramDetail.url) {

                // get current URL
                const currentUrl = window.location.href;
                
                // split URL
                const urlParts = currentUrl.split('/');
            
                // get the last 2 params from the URL
                urlParts[urlParts.length - 2 ] = audioProgramDetail.series_Id;
                urlParts[urlParts.length - 1 ] = audioProgramDetail.program_Id;
                
                // join URL with new values
                const newUrl = urlParts.join('/');
                
                // change iframe surce and show the new URL
                audioPlayerIframe.setAttribute('src', audioProgramDetail.url);
                history.pushState({}, '', newUrl);

                // toggle active class
                audioPlaylistItems.forEach((playlistItem) => {
                    if (playlistItem == item) {
                        playlistItem.classList.add('active');
                    } else {
                        playlistItem.classList.remove('active');
                    }
                });
            }
        })
    })
}

window.changeIframeHeight = function(ID, playerHeight) {
    $(`#${ID}`).css('min-height', playerHeight + 'px');
}